/**
 * A factory that creates instances using a map of constructors that take a Viewer as a first parameter
 * OmitViewer is used to remove the Viewer from the constructor parameters list
 * @param T The type of the constructors map
 * @param _constructors_map The map of constructors
 * @param _viewer The viewer instance
*/
export class ViewerFactory {
    constructor(_constructors_map, _viewer) {
        this._constructors_map = _constructors_map;
        this._viewer = _viewer;
    }
    create(type, ...args) {
        const instance = new this._constructors_map[type](this._viewer, ...args);
        return instance;
    }
}
//# sourceMappingURL=ViewerFactory.js.map